<template>
  <div class="solutions">
    <div class="solutions-header mt-5">
      <el-row justify="center">
        <el-col align="center">
          <figure>
            <img
              class="icon"
              alt="Vue logo"
              :src="data.banner"
            />
          </figure>
        </el-col>
      </el-row>
    </div>

    <el-row justify="center" :gutter="20" class="mt-5" v-if="data.numberBoxes">
      <el-col :span="20" align="center">
        <el-row :gutter="30" justify="space-around">
          <el-col :span="6" :gutter="30" align="center">
            <div class="gradient-box purple-border">
              <div class="gradient-box-content">
                <h3 class="pt-2 pb-1">{{data.numberBoxes[0].value}}</h3>
                <p class="pb-2">{{data.numberBoxes[0].label}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="gradient-box light-blue-border">
              <div class="gradient-box-content">
                <h3 class="pt-2 pb-1">{{data.numberBoxes[1].value}}</h3>
                <p class="pb-2">{{data.numberBoxes[1].label}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="gradient-box green-border">
              <div class="gradient-box-content">
                <h3 class="pt-2 pb-1">{{data.numberBoxes[2].value}}</h3>
                <p class="pb-2">{{data.numberBoxes[2].label}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row justify="center" class="healthcare-title mt-5">
      <el-col align="center">
        <h3>Temos um dos maiores portifólios de healthcare it</h3>
      </el-col>
    </el-row>

    <el-row justify="center" class="healthcare mt-5">
      <el-col :span="22" align="center">
        <el-row>
          <el-col
            align="center"
            :span="8"
            v-for="health in healthcareBoxes"
            :key="health.title"
          >
            <healthcare-box :data="health" @click="handleServicesVisualization(health.component)"/>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine mt-3">
      <el-col :span="22" align="center">
        <component :is="selectedService" :data="data" @close-service="closeService"></component>
      </el-col>
    </el-row>

    <el-row justify="center">
      <el-col :span="22" align="center" @click="showIA">
        <el-row justify="center" class="ia">
          <el-col align="right" :span="12">
            <div class="ia-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Ficons%2Frobot.png?alt=media&token=d8f9c5c8-5405-4c4a-9fa0-19f00272aff0"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="12">
            <el-col align="center">
              <div class="ia-title pt-2">Inteligência Artificial</div>
              <div class="ia-description pt-1">saiba mais</div>
            </el-col>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

     <el-row justify="center" class="medicine mt-3" v-if="openIA">
      <el-col :span="22" align="center">
        <ia :data="data" @close-service="closeService('ia')"></ia>
      </el-col>
    </el-row>

    <el-row justify="center" class="services-title mt-5">
      <el-col  align="center">
        <h3>Prêmios e certificações</h3>
      </el-col>
    </el-row>

     <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center" :span="22">
        <figure>
          <img
            class="premios"
            alt="Vue logo"
            :src="data.rewardsImg"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="services-title mt-5">
      <el-col  align="center">
        <h3>Quais os diferenciais da Pixeon para o mercado de saúde</h3>
      </el-col>
    </el-row>

    <el-row justify="center" class="services mt-5">
      <el-col :span="22" align="center">
        <el-row justify="space-around">
          <el-col
            align="center"
            v-for="service in data.services"
            :span="5"
            :key="service.title"
          >
            <services-box :service="service" />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { ref, onBeforeMount } from 'vue'
import { firebaseRoutes } from '../../config/firebase.conf'

import HealthcareBox from '@/components/healthcareBox/HealthcareBox.vue'
import ServicesBox from '../../components/servicesBox/ServicesBox.vue'
import Medicine from './medicine/Medicine.vue'
import Clinic from './clinic/Clinic.vue'
import Pacient from './pacient/Pacient.vue'
import Ia from './ia/Ia.vue'
export default {
  components: {
    HealthcareBox,
    ServicesBox,
    Medicine,
    Clinic,
    Pacient,
    Ia
  },
  name: 'Solutions',
  setup () {
    const data = ref({})
    const healthcareBoxes = ref([
      {
        title: 'Medicina Diagnóstica',
        component: 'medicine',
        bgColor: 'green',
        categories: [
          {
            icon: 'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Ficons%2Fbreath.png?alt=media&token=2481b9d4-a88f-4a20-a6b4-b4c628030f95',
            title: 'Radiologia',
            description: 'RIS + Pacs'
          },
          {
            icon: 'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Ficons%2Flabs.png?alt=media&token=7d37efcb-616d-489f-a397-536f674197f7',
            title: 'Laboratórios',
            description: 'LIS + INTERFACEAMENTO'
          }
        ]
      },
      {
        title: 'Atenção Clínica',
        component: 'clinic',
        bgColor: 'light-blue',
        categories: [
          {
            icon: 'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Ficons%2Fhospital.png?alt=media&token=6fc0cd8c-fe5f-4fa3-80e7-f20a7b7591b7',
            title: 'Hospitais',
            description: 'HIS'
          },
          {
            icon: 'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Ficons%2Fdocs.png?alt=media&token=adc188ff-80dd-4cd2-8e0c-80bd57a5e0c4',
            title: 'Clínicas',
            description: 'CIS'
          }
        ]
      },
      {
        title: 'Engajamento do Paciente',
        component: 'pacient',
        bgColor: 'blue',
        categories: [
          {
            icon: 'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Ficons%2Fgraph.png?alt=media&token=bf325dd1-ffd3-4cbd-b6a1-8eec87f35aad',
            title: 'Profissionais de Saúde',
            description: 'Sistema de gestão'
          },
          {
            icon: 'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Ficons%2Ftouch.png?alt=media&token=1e9b8f77-9cf7-49d3-855a-fdcbbbd5a834',
            title: 'Pacientes',
            description: 'Agendamento Resultados'
          }
        ]
      }
    ])
    const openIA = ref(false)
    const selectedService = ref('')

    const showIA = () => {
      selectedService.value = ''
      openIA.value = !openIA.value
    }

    const closeService = (ia) => {
      if (ia) {
        openIA.value = false
        return
      }
      selectedService.value = ''
    }

    const handleServicesVisualization = (service) => {
      if (service === 'medicine') {
        selectedService.value === 'medicine' ? selectedService.value = '' : selectedService.value = 'medicine'
        return
      }

      if (service === 'clinic') {
        selectedService.value === 'clinic' ? selectedService.value = '' : selectedService.value = 'clinic'
        return
      }

      if (service === 'pacient') {
        selectedService.value === 'pacient' ? selectedService.value = '' : selectedService.value = 'pacient'
      }
    }

    onBeforeMount(async () => {
      data.value = await axios.get(firebaseRoutes.solucoes).then((response) => {
        const result = []
        for (const id in response.data) {
          result.push({
            id: id,
            banner: response.data[id].banner,
            numberBoxes: response.data[id].numberBoxes,
            medic: response.data[id].medic,
            clinic: response.data[id].clinic,
            pacient: response.data[id].pacient,
            ia: response.data[id].ia,
            rewardsImg: response.data[id].rewardsImg,
            services: response.data[id].services
          })
        }

        return result[0]
      })
    })

    return {
      data,
      healthcareBoxes,
      selectedService,
      showIA,
      openIA,
      closeService,
      handleServicesVisualization
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.solutions-header {
  // @include gradientBackgroundBlueStart;
  img {
    width: 100%;
  }
}

.gradient-box {
  display: flex;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 1.5rem 0.5rem 0 0.5rem;
  position: relative;
  box-sizing: border-box;

  $border: 3px;
  color: #fff;
  background: $bg;
  background-clip: padding-box; /* !importanté */
  border: solid $border transparent; /* !importanté */
  border-radius: 1em;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -$border; /* !importanté */
    border-radius: inherit; /* !importanté */
  }
}

.purple-border {
  &:before {
    background: linear-gradient(
      135deg,
      rgba(102, 52, 225, 1) 0%,
      rgba(74, 199, 233, 1) 47%
    );
  }
}

.light-blue-border {
  &:before {
    background: linear-gradient(
      135deg,
      rgba(74, 199, 233, 1) 47%,
      rgba(74, 199, 233, 1) 47%
    );
  }
}

.green-border {
  &:before {
    background: linear-gradient(
      135deg,
      rgba(74, 199, 233, 1) 0%,
      rgba(33, 190, 165, 1) 100%
    );
  }
}

.gradient-box-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  color: $gray;
  h3 {
    color: $gray;
    font-weight: bold;
    font-size: 4rem;
    text-transform: uppercase;
  }

  p {
    color: $gray;
    font-size: 3.2rem;
    text-transform: uppercase;
  }
}

.healthcare-title {
  text-transform: uppercase;
  h3 {
    color: $green;
    font-size: 3rem;
  }
}

.healthcare {
}

.ia {
  cursor: pointer;
  background-color: $purple;
  color: $white;
  padding: 2rem;
  margin: 0.8rem;
}

.ia-image {
  padding-right: 6rem;

  img {
    height: 7.5rem;
  }
}

.ia-title {
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: uppercase;
}

.ia-description {
  font-size: 1.4rem;
  text-transform: uppercase;
}

.services-title {
  text-transform: uppercase;
  font-weight: bold;
  h3 {
    color: $green;
    max-width: 40%;
    font-size: 3rem;
    line-height: 4rem;
  }
}

.services {
  margin-bottom: 20rem;
}

.premios {
  width: 100%;
}
</style>
